import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import "./index.css";
import "semantic-ui-css/semantic.min.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
